<template>
  <b-dropdown
    id="actions-dropdown"
    :disabled="disabled"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
    hide-on-click-out
    @hide="onDropdownHide"
  >
    <template #button-content>
      <McButton
        variant="secondary"
        icon="icon-outline_chevron-down"
        icon-position="right"
        :text="$t('fleetTaskInstant.action.button')"
        :disabled="disabled"
      />
    </template>

    <b-dropdown-item @click="handleAction(actionHandlers.handleDuplicate)">
      {{ $t('global.duplicate') }}
    </b-dropdown-item>
    <b-dropdown-item class="red-text" @click="handleAction(actionHandlers.handleDelete)">
      {{ $t('global.delete') }}
    </b-dropdown-item>

    <b-dropdown-item class="multilevel-dropdown" @click="handleAction(() => {}, false)">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ $t('global.action.changeStatus') }}</span>
        <i class="icon-outline_chevron-right"></i>
      </div>
      <!-- Invisible box to fill gap between dropdown and child dropdown. If this doesn't exist, the child dropdown disappear when user
       move their cursor to child dropdown -->
      <div class="gap-filler"></div>
      <div class="multilevel-dropdown-menu pr-2">
        <div class="dropdown-menu">
          <b-dropdown-item @click="handleAction(actionHandlers.handleTransitionToScheduled)">
            {{ $t('fleetTask.status.scheduled') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(actionHandlers.handleTransitionToStarted)">
            {{ $t('fleetTask.status.started') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(actionHandlers.handleTransitionToEnded)">
            {{ $t('fleetTask.status.ended') }}
          </b-dropdown-item>
          <b-dropdown-item
            class="red-text"
            @click="handleAction(actionHandlers.handleTransitionToCanceled)"
          >
            {{ $t('fleetTask.status.canceled') }}
          </b-dropdown-item>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    actionHandlers: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      okToHide: true,
    }
  },
  methods: {
    handleAction(handler, shouldClose = true) {
      handler()
      if (!shouldClose) {
        this.okToHide = false
      }
    },
    onDropdownHide(bvEvent) {
      if (!this.okToHide) {
        bvEvent.preventDefault()
        this.okToHide = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
